module.exports = __webpack_public_path__ + "static/media/circleActive.7c5e8b1c.svg";